import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service"
import RolePermissions from '../../CommonModals/Permissions';
// config file
export default class Teachers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      rolesList: [],
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
    this.getRoleListFromServer()
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Facilities');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
    // this.getRoleListFromServer()
  }
  setData = (props) => {
    let rowData = {}
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest('GET', url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = []
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }

          await this.setState({ rolesList: rolesList });
        }
      }).catch((err) => { return err })
  };
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [
      {
        "textAlign": "center",
        "width": 47,
        "field": "Check Box",
        "label": "Check Box",
        "fieldType": "multiple",
        "header": "",
        "selectionMode": "multiple",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "textAlign": "center",
        "width": 47,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "Id",
        "type": "uniqueField",
        "placeholder": "Id",
        "label": "Id",
        "width": "90px",
        "header": "Id",
        "derivedValue": "Id=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Id",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "Id",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "name",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "width": "150px",
        "header": "Name",
        "derivedValue": "name=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "name",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        }
      },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "200px",
        "header": "Email",
        "derivedValue": "email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "email",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "Providers",
        "type": "relateAutoComplete",
        "placeholder": "Providers",
        "label": "Providers",
        "width": "200px",
        "header": "Providers",
        "derivedValue": "Providers=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Providers",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "false",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": true,
        "textAlign": "Center",
        "show": false,
        "field": "Providers",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "120px",
        "header": "Phone Number",
        "derivedValue": "phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "phoneNumber",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "address",
        "type": "textarea",
        "placeholder": "Address",
        "label": "Address",
        "width": "250px",
        "header": "Address",
        "derivedValue": "address=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "address",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "address",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "tax_Id",
        "type": "text",
        "placeholder": "Tax Id",
        "label": "Tax Id",
        "width": "130px",
        "addFormOrder": 6,
        "editFormOrder": 6,
        "header": "Tax Id",
        "derivedValue": "tax_Id=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "tax_Id",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "tax_Id",
        "showOrHideFields": []
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "130px",
        "addFormOrder": 7,
        "editFormOrder": 7,
        "header": "Fax",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "fax",
        "formatType": "US",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "fax",
        "showOrHideFields": []
      },
      {
        "name": "NPI",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "130px",
        "addFormOrder": 8,
        "editFormOrder": 8,
        "header": "NPI",
        "derivedValue": "NPI=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "NPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "NPI",
        "showOrHideFields": []
      },
      {
        "name": "primaryName",
        "type": "text",
        "placeholder": "Primary Name",
        "label": "Primary Name",
        "width": "130px",
        "addFormOrder": 10,
        "editFormOrder": 10,
        "header": "Primary Name",
        "derivedValue": "primaryName=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "primaryName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryName",
        "showOrHideFields": []
      },
      {
        "name": "primaryPhone",
        "type": "text",
        "placeholder": "Primary Phone",
        "label": "Primary Phone",
        "width": "130px",
        "addFormOrder": 11,
        "editFormOrder": 11,
        "header": "Primary Phone",
        "derivedValue": "primaryPhone=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "formatType": "US",
        "actionsNumber": [],
        "id": "primaryPhone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryPhone",
        "showOrHideFields": []
      },
      {
        "name": "primaryEmail",
        "type": "email",
        "placeholder": "Primary Email",
        "label": "Primary Email",
        "width": "150px",
        "addFormOrder": 12,
        "editFormOrder": 12,
        "header": "Primary Email",
        "derivedValue": "primaryEmail=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "primaryEmail",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryEmail",
        "showOrHideFields": []
      },
      {
        "name": "portal",
        "type": "WebSite",
        "placeholder": "Portal",
        "label": "Portal",
        "width": "150px",
        "addFormOrder": 13,
        "editFormOrder": 13,
        "header": "Portal",
        "derivedValue": "portal=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "portal",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "fieldType": "WebSite",
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "portal",
        "showOrHideFields": []
      },
      {
        "name": "hoursOfOperations",
        "type": "textarea",
        "placeholder": "Hours of Operations",
        "label": "Hours of Operations",
        "width": "200px",
        "addFormOrder": 14,
        "editFormOrder": 14,
        "header": "Hours of Operations",
        "derivedValue": "hoursOfOperations=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "hoursOfOperations",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "hoursOfOperations",
        "showOrHideFields": []
      },
      {
        "name": "ReportDistribution",
        "type": "dropDown",
        "placeholder": "Report Distribution",
        "label": "Report Distribution",
        "width": "130px",
        "addFormOrder": 15,
        "editFormOrder": 15,
        "header": "Report Distribution",
        "derivedValue": "ReportDistribution=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "ReportDistribution",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "options": [
          {
            "label": "Email",
            "value": "Email",
            "color": "primary"
          },
          {
            "label": "Fax",
            "value": "Fax",
            "color": "primary"
          },
          {
            "label": "Both",
            "value": "Both",
            "color": "primary"
          },
          {
            "label": "None",
            "value": "None",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": "Email",
            "value": "Email",
            "color": "primary"
          },
          {
            "label": "Fax",
            "value": "Fax",
            "color": "primary"
          },
          {
            "label": "Both",
            "value": "Both",
            "color": "primary"
          },
          {
            "label": "None",
            "value": "None",
            "color": "primary"
          }
        ],
        "dependent": [],
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "ReportDistribution",
        "showOrHideFields": []
      },
      {
        "name": "location",
        "type": "text",
        "placeholder": "Location",
        "label": "Location",
        "width": "130px",
        "addFormOrder": 16,
        "editFormOrder": 16,
        "header": "Location",
        "derivedValue": "location=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "location",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "location",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorName",
        "type": "text",
        "placeholder": "Medical Director Name",
        "label": "Medical Director Name",
        "width": "130px",
        "addFormOrder": 17,
        "editFormOrder": 17,
        "header": "Medical Director Name",
        "derivedValue": "medicalDirectorName=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorName",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorNPI",
        "type": "text",
        "placeholder": "Medical Director NPI",
        "label": "Medical Director NPI",
        "width": "130px",
        "addFormOrder": 18,
        "editFormOrder": 18,
        "header": "Medical Director NPI",
        "derivedValue": "medicalDirectorNPI=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorNPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorNPI",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorPhone",
        "type": "text",
        "placeholder": "Medical Director Phone",
        "label": "Medical Director Phone",
        "width": "130px",
        "addFormOrder": 19,
        "editFormOrder": 19,
        "header": "Medical Director Phone",
        "derivedValue": "medicalDirectorPhone=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "formatType": "US",
        "id": "medicalDirectorPhone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorPhone",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorEmail",
        "type": "email",
        "placeholder": "Medical Director Email",
        "label": "Medical Director Email",
        "width": "150px",
        "addFormOrder": 20,
        "editFormOrder": 20,
        "header": "Medical Director Email",
        "derivedValue": "medicalDirectorEmail=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorEmail",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorEmail",
        "showOrHideFields": []
      },
      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": "120px",
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "fieldType": "date",
        "field": "created",
        "mobile": true,
        "displayInSettings": true,
        "sortable":true,
        "filter":true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": "120px",
        "fieldType": "date",
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "displayInSettings": true,
        "sortable":true,
        "filter":true
      }
    ]
       return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return ([
      {
        "name": "Id",
        "type": "uniqueField",
        "placeholder": "Id",
        "label": "Id",
        "width": "90px",
        "derivedValue": "Id=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "Id",
        "addFormOrder": 1,
        "editFormOrder": 1,
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "name",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "addFormOrder": 2,
        "editFormOrder": 2,
        "width": 110,
        "derivedValue": "name=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        },
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "90px",
        "derivedValue": "email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "Providers",
        "type": "relateAutoComplete",
        "placeholder": "Providers",
        "label": "Providers",
        "width": "90px",
        "addFormOrder": 3,
        "editFormOrder": 3,
        "derivedValue": "Providers=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "Providers",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "false",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [
          
        ],
        "displayFields": [
          
        ],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": true,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "90px",
        "derivedValue": "phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "formatType": "US"
      },
      {
        "name": "address",
        "type": "textarea",
        "placeholder": "Address",
        "label": "Address",
        "width": "90px",
        "derivedValue": "address=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "address",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "tax_Id",
        "type": "text",
        "placeholder": "Tax Id",
        "label": "Tax Id",
        "width": "130px",
        "addFormOrder": 6,
        "editFormOrder": 6,
        "header": "Tax Id",
        "derivedValue": "tax_Id=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "tax_Id",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "tax_Id",
        "showOrHideFields": []
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "130px",
        "addFormOrder": 7,
        "editFormOrder": 7,
        "header": "Fax",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "formatType": "US",
        "actionsNumber": [],
        "id": "fax",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "fax",
        "showOrHideFields": []
      },
      {
        "name": "NPI",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "130px",
        "addFormOrder": 8,
        "editFormOrder": 8,
        "header": "NPI",
        "derivedValue": "NPI=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "NPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "NPI",
        "showOrHideFields": []
      },
      {
        "name": "template",
        "type": "profile",
        "placeholder": "Template",
        "label": "Template",
        "width": "120px",
        "addFormOrder": 9,
        "editFormOrder": 9,
        "header": "Template",
        "derivedValue": "template=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "template",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "imagePath": "facility",
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "addFormOrder": 20,
        "editFormOrder":  20,
        "field": "template",
        "showOrHideFields": []
      },
      {
        "name": "primaryName",
        "type": "text",
        "placeholder": "Primary Name",
        "label": "Primary Name",
        "width": "130px",
        "addFormOrder": 10,
        "editFormOrder": 10,
        "header": "Primary Name",
        "derivedValue": "primaryName=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "primaryName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryName",
        "showOrHideFields": []
      },
      {
        "name": "primaryPhone",
        "type": "text",
        "placeholder": "Primary Phone",
        "label": "Primary Phone",
        "width": "130px",
        "addFormOrder": 11,
        "editFormOrder": 11,
        "header": "Primary Phone",
        "derivedValue": "primaryPhone=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "formatType": "US",
        "actionsNumber": [],
        "id": "primaryPhone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryPhone",
        "showOrHideFields": []
      },
      {
        "name": "primaryEmail",
        "type": "email",
        "placeholder": "Primary Email",
        "label": "Primary Email",
        "width": "150px",
        "addFormOrder": 12,
        "editFormOrder": 12,
        "header": "Primary Email",
        "derivedValue": "primaryEmail=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "primaryEmail",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "primaryEmail",
        "showOrHideFields": []
      },
      {
        "name": "portal",
        "type": "WebSite",
        "placeholder": "Portal",
        "label": "Portal",
        "width": "150px",
        "addFormOrder": 13,
        "editFormOrder": 13,
        "header": "Portal",
        "derivedValue": "portal=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "portal",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "fieldType": "WebSite",
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "portal",
        "showOrHideFields": []
      },
      {
        "name": "hoursOfOperations",
        "type": "textarea",
        "placeholder": "Hours of Operations",
        "label": "Hours of Operations",
        "width": "200px",
        "addFormOrder": 14,
        "editFormOrder": 14,
        "header": "Hours of Operations",
        "derivedValue": "hoursOfOperations=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "hoursOfOperations",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "hoursOfOperations",
        "showOrHideFields": []
      },
      {
        "name": "ReportDistribution",
        "type": "dropDown",
        "placeholder": "Report Distribution",
        "label": "Report Distribution",
        "width": "130px",
        "addFormOrder": 15,
        "editFormOrder": 15,
        "header": "Report Distribution",
        "derivedValue": "ReportDistribution=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "ReportDistribution",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "options": [
          {
            "label": "Email",
            "value": "Email",
            "color": "primary"
          },
          {
            "label": "Fax",
            "value": "Fax",
            "color": "primary"
          },
          {
            "label": "Both",
            "value": "Both",
            "color": "primary"
          },
          {
            "label": "None",
            "value": "None",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": "Email",
            "value": "Email",
            "color": "primary"
          },
          {
            "label": "Fax",
            "value": "Fax",
            "color": "primary"
          },
          {
            "label": "Both",
            "value": "Both",
            "color": "primary"
          },
          {
            "label": "None",
            "value": "None",
            "color": "primary"
          }
        ],
        "dependent": [],
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "ReportDistribution",
        "showOrHideFields": []
      },
      {
        "name": "location",
        "type": "text",
        "placeholder": "Location",
        "label": "Location",
        "width": "130px",
        "addFormOrder": 16,
        "editFormOrder": 16,
        "header": "Location",
        "derivedValue": "location=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "location",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "location",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorName",
        "type": "text",
        "placeholder": "Medical Director Name",
        "label": "Medical Director Name",
        "width": "130px",
        "addFormOrder": 17,
        "editFormOrder": 17,
        "header": "Medical Director Name",
        "derivedValue": "medicalDirectorName=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorName",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorNPI",
        "type": "text",
        "placeholder": "Medical Director NPI",
        "label": "Medical Director NPI",
        "width": "130px",
        "addFormOrder": 18,
        "editFormOrder": 18,
        "header": "Medical Director NPI",
        "derivedValue": "medicalDirectorNPI=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorNPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorNPI",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorPhone",
        "type": "text",
        "placeholder": "Medical Director Phone",
        "label": "Medical Director Phone",
        "width": "130px",
        "addFormOrder": 19,
        "editFormOrder": 19,
        "header": "Medical Director Phone",
        "derivedValue": "medicalDirectorPhone=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "formatType": "US",
        "id": "medicalDirectorPhone",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorPhone",
        "showOrHideFields": []
      },
      {
        "name": "medicalDirectorEmail",
        "type": "email",
        "placeholder": "Medical Director Email",
        "label": "Medical Director Email",
        "width": "150px",
        "addFormOrder": 20,
        "editFormOrder": 20,
        "header": "Medical Director Email",
        "derivedValue": "medicalDirectorEmail=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "medicalDirectorEmail",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "displayinServer": "True",
        "serverFieldType": "String",
        "show": true,
        "field": "medicalDirectorEmail",
        "showOrHideFields": []
      },
      {
        "name": "createdBy",
        "type": "relateAutoComplete",
        "placeholder": "CreatedBy",
        "label": "CreatedBy",
        "width": 90,
        "disabled": true,
        "derivedValue": "createdBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "createdBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updatedBy",
        "type": "relateAutoComplete",
        "placeholder": "UpdatedBy",
        "label": "UpdatedBy",
        "width": 90,
        "derivedValue": "updatedBy=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updatedBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "nadisplayNameme",
        "disabled": true,
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "derivedValue": "created=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "derivedValue": "updated=undefined",
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "password",
        "type": "password",
        "placeholder": "Password",
        "label": "Password",
        "width": "90px",
        "derivedValue": "password=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [
          
        ],
        "actionsNumber": [
          
        ],
        "id": "password",
        "displayinaddForm": "true",
        "displayineditForm": "false",
        "displayinlist": "false",
        "isFieldRequired": "false",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [
          
        ],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": true
      }
    ]);
  }


  submit = async (item) => {

    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');

    console.log("Submit Button in sode          ")
  }
  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"Id","type":"uniqueField","placeholder":"Id","label":"Id","width":"90px","header":"Id","derivedValue":"Id=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"Id","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"Id","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","width":110,"header":"Name","derivedValue":"name=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"name","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"email","type":"email","placeholder":"Email","label":"Email","width":"90px","header":"Email","derivedValue":"email=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"email","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"email","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"Providers","type":"relateAutoComplete","placeholder":"Providers","label":"Providers","width":"90px","header":"Providers","derivedValue":"Providers=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"Providers","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1010,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"providers","searchApi":"providerss","isMultiple":true,"textAlign":"Center","show":false,"field":"Providers","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"phoneNumber","type":"text","placeholder":"Phone Number","label":"Phone Number","width":"90px","header":"Phone Number","derivedValue":"phoneNumber=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"phoneNumber","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"phoneNumber","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"address","type":"textarea","placeholder":"Address","label":"Address","width":"90px","header":"Address","derivedValue":"address=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"address","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"address","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = facilitiessFields
  //   let objfacilitiess = {}

  //   objfacilitiess["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objfacilitiess[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objfacilitiess,
  //     newFormFields: formFields
  //   });
  // }
  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  getChangedRoleOptions = () => {
    let fields = this.getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = this.state.rolesList && this.state.rolesList.length > 0 ? this.state.rolesList : []
        }
      }
    }
    return fields;
  }
  saveDataToServer = async (item, field, value) => {
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.Facilitiess}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <span>
        <DataTables
          {...this.props}
          onRef={ref => (this.dataTableRef = ref)}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          // 
addRequired={ false}
editRequired={false}
deleteRequired={ false}
viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
sample={true}
          // globalSearch={'Display Name/Email'}
          // type='Facilitiess'
          // apiUrl={apiCalls.Facilitiess}
          getTableFields={this.getTableFields}
          formFields={this.getChangedRoleOptions}
          // exportRequried={true}

          printRequried={true}
          actionsTypes={[
            // {
            //   'name': 'Edit',
            //   "options": [
            //     { 'label': 'Edit', 'value': 'Edit', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": false, },
            //   ]
            // },
            // {
            //   'name': 'Delete',
            //   "options": [
            //     { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
            //   ]
            // },
            
            // {
            //   'name': 'Block',
            //   "options": [
            //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'ResetPassword',
            //   "options": [
            //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'Submit',
            //   'action': this.submit,
            //   "options": [
            //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
            //   ]
            // },
            // {
            //   name: "newModel",
            //   action: this.submit1,
            //   options: [
            //     { label: "newModel", value: "newModel", show: true, multiple: false }
            //   ]
            // }
            
          ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          sampleFilePath={filePath.facilitiess}
          setData={this.setData}
          editSelectedRecord={this.state.editSelectedRecord}
          addSelectedRecord={this.state.addSelectedRecord}
          viewSelectedRecord={this.state.viewSelectedRecord}
          globalSearch={"name/email/phoneNumber/address"}
          type='Facilities'
          routeTo={apiCalls.Facilitiess}
          displayViewOfForm='screen'
          apiResponseKey={apiCalls.Facilitiess}
          apiUrl={apiCalls.Facilitiess}

        />
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="Facilities"
            apiUrl={apiCalls.Facilitiess}
          />
        ) : null}
      </span>
    );
  }
}